<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n';

const {   t } = useI18n();

import { useRouter } from 'vue-router'
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import {getBannerApi, getNewsArticleQueryApi} from "@/api";
const bannerList = ref([]), info = ref([])
function getNewsArticleQuery (){
  getNewsArticleQueryApi({type:9}).then(res =>{
    info.value = res.data
  })
}
function  getBanner (){
  getBannerApi({type:9}).then(res => {
    bannerList.value = res.data
  })
}
const router = useRouter()
const id = router.currentRoute.value.query.id
console.log(id ,"2")
getBanner()
getNewsArticleQuery()
</script>

<template>

  <div class="box">
    <HeaderNav :isCurrent="8" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--产品展示 开始-->
    <div class="single">
      <!--右侧区域 开始-->
      <div id="right">
        <div class="right_title">
          <!--当前位置 开始-->
          <div id="location">
            <a href="/" target="_self">{{ t('首页') }}</a> &nbsp;&gt;&gt;&nbsp;
            <a href="javascript:;">{{ t('联系我们') }}</a>
          </div>
          <!--当前位置 结束-->
          <h2>{{ t('联系我们') }}</h2>
        </div>
        <div class="right_body minwidth">
          <div class="ChannelContent">
            <div class="ContactInfo">
              <div v-html="info.content"></div>
              <!-- <div class="Company">{{t('公司')}}：某某服装有限公司</div> -->
              <!-- <div class="Contact"><strong>{{t('联系人')}}：</strong> 陈小姐</div> -->
              <!-- <div class="Telephone"><strong>{{t('电话')}}：</strong> 010-456123444</div> -->
              <!-- <div class="Fax"><strong>{{t('传真')}}：</strong> 010-456123444</div> -->
              <!-- <div class="Email"><strong>{{t('邮件')}}：</strong> 123456789000@qq.com</div> -->
              <!-- <div class="PostCode"><strong>{{t('邮政编码')}}：</strong> 400000</div> -->
              <!-- <div class="WebUrl"> -->
              <!--   <strong>{{t('网址')}}：</strong> <a class="WebUrl" href="http://www.baidu.com" target="_blank" rel="noopener"> http://www.baidu.com</a> -->
              <!-- </div> -->
              <!-- <div class="Address"><strong>{{t('地址')}}：</strong> 河北省唐山市某某工业区某某大厦12层1205</div> -->
            </div>
          </div>
        </div>
        <div class="right_bottom"></div>
      </div>
      <!--右侧区域 结束-->
      <div class="clear"></div>
    </div>
    <!--产品展示 结束-->

    <FootNav />
  </div>
</template>

<style scoped lang="scss">
.video-details {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    color: #333;
    margin-bottom: 20px;
  }

  .video-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>